import React from 'react';
import { Box, Stack, Typography, Link, useMediaQuery } from '@mui/material';
import Logo from '../assets/images/Logo-1.png';
import { Instagram } from '@mui/icons-material';

const Footer = () => {
  const isSmallDevice = useMediaQuery('(max-width:600px)');

  return (
    <Box mt="10px" bgcolor="#fff3f4">
      <Stack alignItems="center" px="20px" pt="12px">
        <img src={Logo} alt="logo" width={isSmallDevice ? '200px' : '500px'} height={isSmallDevice ? '80px' : '200px'} />
        <Typography
          variant="h4"
          pb={isSmallDevice ? '20px' : '40px'}
          mt="1px"
          color="#6A0DAD"
          textAlign="center"
        >
          Made with ❤️ by Group 18.
        </Typography>
        <Stack spacing={2} direction={isSmallDevice ? 'row' : 'row'} alignItems={isSmallDevice ? 'center' : 'flex-start'}>
          <Stack direction="row" alignItems="center">
            <Instagram sx={iconStyles} />
            <Typography variant="h6" color="#6A0DAD">
              <Link
                href="https://instagram.com/_.aneeshkandal._?igshid=NGExMmI2YTkyZg=="
                target="_blank"
                rel="noopener noreferrer"
              >
                Aneesh
              </Link>
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center">
            <Instagram sx={iconStyles} />
            <Typography variant="h6" color="#6A0DAD">
              <Link
                href="https://instagram.com/ishreyxs?igshid=MzNlNGNkZWQ4Mg=="
                target="_blank"
                rel="noopener noreferrer"
              >
                Shreyas
              </Link>
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center">
            <Instagram sx={iconStyles} />
            <Typography variant="h6" color="#6A0DAD">
              <Link
                href="https://instagram.com/mahimakale2103?igshid=MzRlODBiNWFlZA=="
                target="_blank"
                rel="noopener noreferrer"
              >
                Mahima
              </Link>
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

const iconStyles = {
  fontSize: '40px',
  color: '#6A0DAD',
};

export default Footer;
